import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e90b60c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "authorize-page container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Authorize app", -1))
const _hoisted_3 = {
  key: 1,
  class: "error"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "consent-message" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "wants to access your Tree Crossing account.", -1))

import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useTokenManager } from './TokenManager'
import { useTelemetry } from '@/util/Telemetry'
import { LocalTokenApi, tokenClientIcons } from './LocalTokenApi'
import { usePageTitle } from '@/util/AppUtil'
import Spinner from '@/util/Spinner.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorizePage',
  setup(__props) {

const busyRef = ref(true)
const errorRef = ref<string>()
const clientNameRef = ref<string>()

const route = useRoute()
const router = useRouter()
const tokenManager = useTokenManager()
const { trackException } = useTelemetry()

usePageTitle('Authorize app')

const clientId = computed(() => route.query.client_id as string)
const redirectUri = computed(() => route.query.redirect_uri as string)
const codeChallenge = computed(() => route.query.code_challenge as string)
const codeChallengeMethod = computed(() => route.query.code_challenge_method as string)
const state = computed(() => route.query.state as string)
const clientIcon = computed(() => tokenClientIcons.get(clientId.value))

function redirectWithParams(params: Record<string, string | undefined>) {
  const url = new URL(redirectUri.value)
  for (const [key, value] of Object.entries(params)) {
    if (value) url.searchParams.set(key, value)
  }
  window.location.href = url.toString()
}

onMounted(async () => {
  if (!tokenManager.current.isValid) {
    // Try refreshing an expired token before redirecting to sign in
    if (!await tokenManager.ensureRefreshedAsync()) {
      router.push({ path: '/signin', query: { redirect_uri: route.fullPath } })
      return
    }
  }

  if (!redirectUri.value || !codeChallenge.value || !codeChallengeMethod.value) {
    errorRef.value = 'Invalid authorization request.'
    busyRef.value = false
    return
  }

  try {
    const clientInfo = await LocalTokenApi.getTokenClientAsync(tokenManager.current.token, clientId.value)
    clientNameRef.value = clientInfo.name
  }
  catch {
    errorRef.value = 'Unknown application'
  }

  busyRef.value = false
})

async function allow() {
  try {
    busyRef.value = true
    const result = await LocalTokenApi.getLocalAuthCodeAsync(
      tokenManager.current.token, clientId.value, {
        redirectUri: redirectUri.value,
        codeChallenge: codeChallenge.value,
        codeChallengeMethod: codeChallengeMethod.value,
      })

    redirectWithParams({ code: result.code, state: state.value })
  }
  catch (error) {
    trackException(error)
    errorRef.value = 'Something went wrong. Please try again.'
    busyRef.value = false
  }
}

function deny() {
  redirectWithParams({ error: 'access_denied', state: state.value })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (busyRef.value)
      ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
      : (errorRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorRef.value), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (clientIcon.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: clientIcon.value,
                  class: "client-icon"
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("strong", null, _toDisplayString(clientNameRef.value), 1),
              _hoisted_6
            ]),
            _createElementVNode("div", { class: "actions" }, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: allow
              }, "Allow"),
              _createElementVNode("button", {
                class: "btn btn-outline-secondary",
                onClick: deny
              }, "Deny")
            ])
          ], 64))
  ]))
}
}

})